module.exports = __webpack_public_path__ + "img/blibli.18d20b41.png";